import api from "../../axiosConfig";

export const addConsultFee = async (formData,doctor_id) => {

    try {

      const response = await api.post(`consultantion-fee/add-update/${doctor_id}`, formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success' || resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getConsultFee = async (doctor_id,date) => {
  try {
    const response = await api.get(`consultantion-fee/get/${doctor_id}`)

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching SHifts');
  }
};

export const updateConsultFee = async (doctor_id, formData) => {


  try {
    const response = await api.post(`consultantion-fee/add-update${doctor_id}`, formData);

    const resData = response?.data;
    console.log('Update shifts response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating shift');
  }
};
